import * as types from "../ActionType";

const initState = {
    profileDetails: null,
    loadingProfileDetails: true
}

const ProfileReducer = (state = initState, action) => {
    switch (action.type) {
        case types.GET_PROFILE_DETAILS:
            return { ...state, profileDetails: action.payload, loadingProfileDetails: false }
        case types.EDIT_PROFILE_DETAILS:
            return { ...state }
        default:
            return state;
    }
};

export default ProfileReducer;
